function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.27297 9.154C6.08018 9.15608 3.97723 10.0482 2.42554 11.6302C0.875889 13.2164 0.0020417 15.3612 0 17.5998C0 17.6769 0.0306255 17.752 0.0837097 17.8062C0.136794 17.8603 0.210295 17.8916 0.285838 17.8916H16.2621C16.3377 17.8916 16.4112 17.8603 16.4643 17.8062C16.5174 17.752 16.548 17.6769 16.548 17.5998C16.5459 15.3612 15.6721 13.2143 14.1224 11.6302C12.5687 10.0482 10.4658 9.15817 8.27297 9.154ZM4.56524 4.78519C4.56524 3.78053 4.95521 2.81756 5.65143 2.10888C6.3456 1.39811 7.28887 1 8.27297 1C9.25707 1 10.2003 1.39811 10.8945 2.10888C11.5907 2.81964 11.9807 3.78261 11.9807 4.78519C11.9807 5.78776 11.5907 6.75282 10.8945 7.4615C10.1983 8.17227 9.25503 8.57038 8.27297 8.57038C7.29091 8.56829 6.34765 8.17018 5.65143 7.45942C4.95725 6.75282 4.56524 5.78985 4.56524 4.78519Z",
  fill: "#8E8B99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.6958 11.9842L26.6958 7.3799L19.3988 7.3799L19.3988 11.9842L26.6958 11.9842Z",
  fill: "#8E8B99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.9993 18.0013L32.9993 13.3969L19.3975 13.3969L19.3975 18.0013L32.9993 18.0013Z",
  fill: "#8E8B99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8317 5.96813V1.36378L19.3971 1.36378V5.96813L23.8317 5.96813Z",
  fill: "#8E8B99"
}));

var SvgVisitsSideBarIcon = function SvgVisitsSideBarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 17,
    viewBox: "0 0 33 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisitsSideBarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visitsSideBarIcon.6b5f2739.svg";
export { ForwardRef as ReactComponent };